import CustomButton from "../../../../components/CustomButton";
import {
  crudRoutes,
  inventoryRoutes,
} from "../../../../router/routesConstants";
import Text from "../../../../styleguide/Text";

export default function PickingBoxesHeader() {
  return (
    <div className="flex flex-wrap justify-between items-center gap-3 mb-6">
      <Text
        variant="h3"
        component="h3"
        className="font-semibold text-slate-900">
        Stoc cutii picking
      </Text>
      <CustomButton
        variant="contained"
        icon="ADD"
        tooltipTitle="Deschide formularul de adaugare a unei cutii de picking."
        aria-label="Adauga cutie"
        navigate={`/${inventoryRoutes.inventory}/${inventoryRoutes.pickingBoxStocks}/${crudRoutes.create}`}>
        Adauga cutie
      </CustomButton>
    </div>
  );
}
